import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

import Logo from '../../assets/images/truelark_icon.svg';
import Profile from '../Header/img/profile.png'

class StaffAssignListItem extends React.Component {
  constructor(props) {
    super(props);

    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    this.props.onClick(this.props.staff);
  }

  render() {
    let isSelected = this.props.assignedTo===this.props.id;
    let item = (
      <NavLink to={this.props.path} className="dropdown-menu__item">
        {this.props.label}
      </NavLink>
    );

    const itemProps = {
      onClick: this.onClick,
    };

    if (this.props.type === 'BUTTON') {
      item = (
        <div
          className={classnames('dropdown-menu__item', this.props.className)}
          {...itemProps}
        >
        <div className="dropdown-menu__item_element">
            <div className="dropdown-menu__item_element_data">
                {this.props.label?
                (this.props.isOtherStaff?(<div className="logo"> <img src={Profile} /></div>):(<div className="logo">{this.props.logoname}</div>)):
                (<div className="none"> <img src={Logo} /></div>)}
                 {this.props.label?(<div className={classnames('name',{'selected-staff':isSelected})}>{this.props.label}</div>)
                 :(<div className={classnames('name',{'selected-staff':isSelected})}>TrueLark Auto-response</div>)}
            </div>
            {isSelected&&<div><i className="material-icons">check</i></div>}
        </div>
        </div>
      );
    }

    return item;
  }
}

StaffAssignListItem.defaultProps = {
  label: '',
  path: '',
  type: 'LINK',
  onClick: () => {},
  value: '',
};

StaffAssignListItem.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  path: PropTypes.string,
  type: PropTypes.oneOf(['LINK', 'BUTTON']),
  onClick: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default StaffAssignListItem;
